import { wssProtocol } from "@/common/config"
import { TableHub } from "../common/tableHub"
import { Object, SimpleObject } from "../model/object"

export class ObjectRepository {
    watcher: TableHub<Object>

    constructor() {
        let wss = wssProtocol()
        this.watcher = new TableHub<Object>(`${wss}://${location.host}/api/ws/objects/{id}`)
    }

    async list():Promise<SimpleObject[]> {
        return fetch('/api/schema/objects').then((response) => { 
            return response.json()
        });
    }
}